// extracted by css-extract-rspack-plugin
export default {"item":"_8d71cf41"};